import { useEffect } from 'react';
import Footer from '../../Utils/Footer/footer-component'
import About from './AboutUs';
import Layout from '../../Utils/Navbar/navbar-layout-component.js';
import Contact from '../Contact-screen/Contact.js';
import QuickCallSection from '../../Utils/Sections/section-quick-call-component.js';

function AboutScreen() {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className="flex w-full flex-col">
            <div>
                <Layout>
                    <About />
                    {/* <QuickCallSection /> */}
                </Layout>
                <Contact />
                <Footer />
            </div>

        </div>
    );
}

export default AboutScreen;